import { render } from "./ProcessSteps.vue?vue&type=template&id=bfcfde40&scoped=true"
import script from "./ProcessSteps.vue?vue&type=script&lang=js"
export * from "./ProcessSteps.vue?vue&type=script&lang=js"

import "./ProcessSteps.vue?vue&type=style&index=0&id=bfcfde40&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfcfde40"]])

export default __exports__